<section
  appMovingGradient
  class="search-panel"
  [class.sidebar-panel]="!isFullWidth()"
  [class.full-panel]="isFullWidth()"
>
  <form class="form" (ngSubmit)="handleSubmit()">
    <div class="panel-header">
      <app-search-action
        placeholderLang="common.actions.search-title"
        class="w-full"
        [parentSearchTextControl]="searchFormControl"
        (submitSearch)="handleSubmit()"
        [loading]="isDocumentsLoading()"
        [isShow]="panelCollapsed()"
        [compact]="!isFullWidth()"
      />
      <sk-button
        [ariaLabel]="'common.filter.advanced-search' | lang"
        [attr.aria-expanded]="!panelCollapsed()"
        (clicked)="panelCollapsed.update(value => !value)"
      >
        <re-icon name="filter-setting" appearance="light" />
      </sk-button>
    </div>

    <div
      class="filter-content"
      [class.filter-content-open]="!panelCollapsed()"
      [attr.aria-hidden]="panelCollapsed()"
      [attr.inert]="panelCollapsed() ? '' : null"
    >
      <div class="filter-content-inner">
        <div class="form-dropdown-box" [class.form-dropdown-box-full]="isFullWidth()">
          <sk-field [label]="'common.filter.document-type' | lang">
            <sk-autocomplete
              #typeAutocomplete
              [(value)]="typeCandidate"
              [options]="availableTypeOptions()"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'common.actions.search' | lang"
              [ariaLabel]="'common.filter.document-type' | lang"
              (selected)="addType($event)"
            />
            @if (types().length) {
            <div class="type-selection" aria-live="polite">
              @for (type of types(); track type) {
              <span class="type-chip">
                {{ typeLabel(type) }}
                <button
                  type="button"
                  [attr.aria-label]="('common.filter.remove-document-type' | lang) + ': ' + typeLabel(type)"
                  (click)="removeType(type)"
                >
                  <re-icon name="cross" width="10" height="10" color="currentColor" />
                </button>
              </span>
              }
            </div>
            }
          </sk-field>

          <sk-field [label]="'common.filter.document-number' | lang">
            <sk-input-text [(value)]="documentNumber" [placeholder]="'common.placeholders.input' | lang" />
          </sk-field>

          <sk-field [label]="'common.actions.search-text' | lang">
            <sk-input-text [(value)]="content" [placeholder]="'common.placeholders.input' | lang" />
          </sk-field>

          <sk-field [label]="'common.filter.document-status' | lang">
            <sk-multi-select
              [filter]="true"
              [clearable]="true"
              [(value)]="statuses"
              [options]="dictService.statuses.options()"
              [placeholder]="'common.placeholders.select' | lang"
            />
          </sk-field>

          @if (showSorting()) {
          <sk-field [label]="'common.filter.sort-by' | lang">
            <sk-select
              [(value)]="sortBy"
              [options]="sortOptions"
              optionValue="value"
              [optionLabel]="localizedSortLabel"
              [placeholder]="'common.placeholders.select' | lang"
              [ariaLabel]="'common.filter.sort-by' | lang"
            />
          </sk-field>
          }

          <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
            <sk-field [label]="'common.filter.date-adoption-from' | lang">
              <sk-date-picker
                dateFormat="dd.MM.yyyy"
                [(value)]="dateFrom"
                [placeholder]="'common.filter.date-placeholder' | lang"
                [showIcon]="true"
              />
            </sk-field>

            <sk-field [label]="'common.filter.date-adoption-to' | lang">
              <sk-date-picker
                dateFormat="dd.MM.yyyy"
                [(value)]="dateTo"
                [placeholder]="'common.filter.date-placeholder' | lang"
                [showIcon]="true"
              />
            </sk-field>
          </div>
        </div>

        <div class="filter-submit flex justify-end mt-4">
          <sk-button
            type="submit"
            size="small"
            [label]="'common.actions.search' | lang"
            [loading]="isDocumentsLoading()"
          />
        </div>
      </div>
    </div>
  </form>
</section>
